import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiX } = FiIcons;

export default function ReconciliationMatchModal({
  accountName,
  isReconciling,
  onClose,
  onReconcileAutomatically,
  onReconcileManually
}) {
  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-slate-900/55 p-4 backdrop-blur-sm">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="reconciliation-match-title"
        className="relative w-full max-w-2xl overflow-hidden rounded-3xl bg-white px-6 py-10 text-center shadow-2xl sm:px-12"
      >
        <button
          type="button"
          onClick={onClose}
          disabled={isReconciling}
          className="absolute right-5 top-5 rounded-full p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700 disabled:cursor-not-allowed disabled:opacity-50"
          aria-label="Close balance match confirmation"
        >
          <SafeIcon icon={FiX} className="text-xl" />
        </button>

        <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full border-4 border-emerald-100 bg-emerald-600 text-white shadow-lg shadow-emerald-200">
          <SafeIcon icon={FiCheckCircle} className="text-5xl" />
        </div>

        <h2
          id="reconciliation-match-title"
          className="mx-auto mt-7 max-w-lg text-3xl font-black tracking-tight text-slate-900 sm:text-4xl"
        >
          Your books and statement balances match!
        </h2>

        <p className="mx-auto mt-4 max-w-xl text-base font-medium leading-relaxed text-slate-600 sm:text-lg">
          Your {accountName} account is ready to reconcile. Reconcile everything
          automatically, or review and match transactions manually.
        </p>

        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <button
            type="button"
            onClick={onReconcileManually}
            disabled={isReconciling}
            className="rounded-xl border-2 border-blue-600 px-6 py-3 text-sm font-black text-blue-700 transition-all hover:bg-blue-50 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Reconcile manually
          </button>
          <button
            type="button"
            onClick={onReconcileAutomatically}
            disabled={isReconciling}
            className="rounded-xl bg-blue-600 px-6 py-3 text-sm font-black text-white shadow-lg shadow-blue-200 transition-all hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-blue-300"
          >
            {isReconciling ? 'Reconciling...' : 'Reconcile automatically'}
          </button>
        </div>
      </div>
    </div>
  );
}